import UserEventContextValueProvider from "../../App/Compositions/UserEventContextValueProvider";
import NextButtonDesktop from "../Components/NextButtonDesktop";

/** A value provider which provisions user event context values to the {@link NextButtonDesktop}. */
const UserEventNextButtonDesktop = UserEventContextValueProvider({ Component: NextButtonDesktop });

export default UserEventNextButtonDesktop;
